// extracted by mini-css-extract-plugin
export default {"authenticationTitle":"Authentication_authenticationTitle__EQHap"};